import { useQuery } from '@tanstack/react-query';
import { useUserCity } from '../../../../Common/hooks/useUserCity';
import config from '../../../../../../config/config';
import Fetch from '../../../../../../../core/util/core/Fetch';
import { getUserSession } from '../../../../../../util/core/Session';

const useLocations = (cityId) => {
    const { data } = useUserCity();
    const session = getUserSession();

    const profile = session.user.application_profile_id;

    const isCityManager =
        profile === config.default_foreign_key.sdg_profiles.cityManager;

    const city = isCityManager ? data?.city_id : cityId;

    return useQuery({
        queryKey: ['cities', city],
        queryFn: async () => {
            return await Fetch.post(
                config.endpoints.backend +
                    'governanceroom/dashboard/vitalstatistics/cities',
                {
                    filters: {
                        co_ibge: city
                    }
                }
            );
        },
        enabled: !!city
    });
};

export default useLocations;
